var React = require('react');

function FbInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Pfad_1","d":"M3.68,10.89l0,-4.96l1.69,0l0.24,-1.94l-1.93,0l0,-1.21c0,-0.54 0.18,-0.97 0.97,-0.97l1.03,0l0,-1.75c-0.24,0 -0.85,-0.06 -1.51,-0.06c-1.45,0 -2.48,0.91 -2.48,2.54l0,1.45l-1.69,0l0,1.94l1.69,0l0,4.96l1.99,0Z","style":{"fill":"#010202"}}));
}

FbInline.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 6 11","version":"1.1","xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"},"className":"ark-svg"};

module.exports = FbInline;

FbInline.default = FbInline;
